const getEngineDropdownQuery = /* GraphQL */ `
  query GetEngineDropdown($request: EngineDropdownRequestInput) {
    engineData: engineDropdown(request: $request) {
      engineMakeDropdown {
        optionId
        displayName
      }
      engineFamilyDropdown {
        optionId
        displayName
        shopUrl
        searchUrl
      }
      engineDisplacementDropdown {
        optionId
        displayName
        shopUrl
        searchUrl
      }
    }
  }
`

export default getEngineDropdownQuery
